/* External */
import {
  useCallback,
  useEffect,
  useState,
} from 'react';

/* Utils */
import { fetchMoreLikeThisVODService } from '../services/morelikethis';

export default function useFetchMoreLikeThisVod({
  contentId,
  tryFetchAgain,
  isDisplaying,
}) {
  const [isFetchingVod, setIsFetchingVod] = useState(true);
  const [moreLikeThisItemsVod, setMoreLikeThisItemsVod] = useState([]);
  const [moreLikeThisTitleVod, setMoreLikeThisTitleVod] = useState('');
  const [errorVod, setErrorVod] = useState(undefined);

  const getMoreLikeThisVOD = useCallback(() => {
    setIsFetchingVod(true);
    fetchMoreLikeThisVODService(contentId).then((response) => {
      const { data: { contents, title } } = response;

      setMoreLikeThisItemsVod(contents);
      setMoreLikeThisTitleVod(title);
      setIsFetchingVod(false);
      return true;
    }).catch((error) => {
      console.error('moreLikeThis>useFetchMoreLikeThisVod', error);
      setErrorVod(error);
      setIsFetchingVod(false);
      return false;
    });
  }, [contentId]);

  useEffect(() => {
    if (contentId && isDisplaying) {
      getMoreLikeThisVOD();
    }
  }, [
    getMoreLikeThisVOD,
    contentId,
    isDisplaying,
    tryFetchAgain,
  ]);

  return {
    moreLikeThisItemsVod,
    moreLikeThisTitleVod,
    isFetchingVod,
    errorVod,
  };
}
